// extracted by mini-css-extract-plugin
export default {"alignmentControls":"textAlignment_alignmentControls__4Ui7K"};